import { render, staticRenderFns } from "./HistoricoCompras.vue?vue&type=template&id=5cca50e2&scoped=true"
import script from "./HistoricoCompras.vue?vue&type=script&lang=js"
export * from "./HistoricoCompras.vue?vue&type=script&lang=js"
import style0 from "./HistoricoCompras.vue?vue&type=style&index=0&id=5cca50e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca50e2",
  null
  
)

export default component.exports